import { render } from "./PokemonOptions.vue?vue&type=template&id=72541696&scoped=true"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=72541696&scoped=true&lang=css"

import exportComponent from "D:\\CarlosRocha\\Vue\\Pokemon Game Wirh Vue\\04-pokemon-game-with-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72541696"]])

export default __exports__